import { useReveal } from './hooks';
import { Nav } from './components/Nav';
import { Hero } from './components/Hero';
import { LogoStrip } from './components/LogoStrip';
import { ProblemSolution } from './components/ProblemSolution';
import { UseCases } from './components/UseCases';
import { HowItWorks } from './components/HowItWorks';
import { SocialProof } from './components/SocialProof';
import { WhoFor } from './components/WhoFor';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';

export function Landing() {
  useReveal();
  return (
    <div className="lp">
      <Nav />
      <Hero />
      <LogoStrip />
      <ProblemSolution />
      <UseCases />
      <HowItWorks />
      <SocialProof />
      <WhoFor />
      <FAQ />
      <FinalCTA />
      <Footer />
    </div>
  );
}
